/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 15:03:10
 *
 *******************************************************/

export const DASHBOARD_LAYOUT = [
  ['topNotifications'],
  ['welcome1'],
  ['welcome2'],
  ['welcomeOnboarding'],
  ['welcomeAppEngagement'],
  ['europeanLanguageNotification'],
  ['onboardingChecklist'],
  ['onboardingArticles'],
  ['notifications'],
  ['review'],
  ['themeSetupStatus', 'subscriptionStatus'],
  ['optionInEmail'],
  ['menuDashboard1'],
  ['menuDashboardAppEngagement'],
  ['syncHookStatus'],
  ['gettingStartedVideos'],
  ['guideToKnowledgeBase'],
  ['guideToKnowledgeBaseAppEngagement'],
  ['recommendedApps'],
  ['helpCenter'],
  ['feedback']
];

export const OnboardingNewFeatureStep = [
  'old-customer-welcome',
  'old-customer-feature-updates',
  'old-customer-recommendation-widget',
  'old-customer-add-ons',
  'old-customer-setup-theme',
  'old-customer-done-onboarding'
];

export const DASHBOARD_LAYOUT_TOP = [
  ['marketingBanner'],
  ['welcome3'],
  ['upgradeTurbo'],
  ['notifications'],
  ['quickStartGuide'],
  ['crossSellUpSell']
];

export const DASHBOARD_LAYOUT_FIRST_COLUMN = [
  ['subscriptionStatus', 'themeSetupStatus'],
  ['getSupport'],
  ['optionInEmail']
];

export const DASHBOARD_LAYOUT_SECOND_COLUMN = [
  ['syncHookStatus'],
  ['changeLogs'],
  ['recommendedApps']
];

export const DashboardDismissChoices = [
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionUserful',
    value: 'userful'
  },
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionNotUseful',
    value: 'notUseful'
  },
  {
    label: 'AdminHTML.Dashboard.BlockCanDismiss.feedback_OptionAppearOften',
    value: 'appearOften'
  }
];

export const DASHBOARD_BLOCKS_DEFAULT = {
  themeSetupStatus: true,
  menuDashboard1: true,
  syncHookStatus: true,
  gettingStartedVideos: true,
  guideToKnowledgeBase: true,
  helpCenter: true,
  subscriptionStatus: true,
  onboardingChecklist: true,
  welcomeOnboarding: true,
  feedback: true
};
